import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FollowCampaignComponent } from './follow-campaign.component';
import { MatButtonModule } from '@angular/material/button';
import { InputModule } from '../input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { SharedModule } from '../../shared/shared.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';



@NgModule({
  declarations: [
    FollowCampaignComponent
  ],
  exports: [
    FollowCampaignComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    InputModule,
    ReactiveFormsModule,
    ModuleLoaderModule,
    MatDialogModule,
    MatBottomSheetModule,
    CloseBtnModule,
    SharedModule,
    IntlInputModule,
    CaptchaInputModule
  ]
})
export class FollowCampaignModule { }
